
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./initializers/ember-data-identifiers.js"
import * as amdModule1 from "./lib/checkout-contact-controller.js"
import * as amdModule2 from "./lib/checkout-payload.js"
import * as amdModule3 from "./lib/confirm-error.js"
import * as amdModule4 from "./lib/default-comprensorio.js"
import * as amdModule5 from "./lib/fiscal-contact-validation.js"
import * as amdModule6 from "./resolver.js"
import * as amdModule7 from "./router.js"
import * as amdModule8 from "./serializers/application.js"
import * as amdModule9 from "./services/intl.js"
import * as amdModule10 from "./services/keyboard.js"
import * as amdModule11 from "./services/theme.js"
import * as amdModule12 from "./services/-ensure-registered.js"
import * as amdModule13 from "./services/notify.js"
import * as amdModule14 from "./initializers/app-version.js"
import * as amdModule15 from "./instance-initializers/sentry-performance.js"
import * as amdModule16 from "./instance-initializers/load-translations.js"
import * as amdModule17 from "./services/power-calendar.js"
import * as amdModule18 from "./test-support/helpers.js"
import * as amdModule19 from "./initializers/ember-data.js"
import * as amdModule20 from "./services/store.js"
import * as amdModule21 from "./transforms/date.js"
import * as amdModule22 from "./transforms/number.js"
import * as amdModule23 from "./transforms/string.js"
import * as amdModule24 from "./transforms/boolean.js"
import * as amdModule25 from "./data-adapter.js"
import * as amdModule26 from "./services/quill.js"
import * as amdModule27 from "./adapters/application.js"
import * as amdModule28 from "./adapters/contact.js"
import * as amdModule29 from "./adapters/organization.js"
import * as amdModule30 from "./models/address.js"
import * as amdModule31 from "./models/application.js"
import * as amdModule32 from "./models/assurance.js"
import * as amdModule33 from "./models/category.js"
import * as amdModule34 from "./models/contact-consensi.js"
import * as amdModule35 from "./models/contact-parent.js"
import * as amdModule36 from "./models/contact-state.js"
import * as amdModule37 from "./models/contact.js"
import * as amdModule38 from "./models/custom-field-definition.js"
import * as amdModule39 from "./models/custom-field.js"
import * as amdModule40 from "./models/custom-reminder.js"
import * as amdModule41 from "./models/event-state.js"
import * as amdModule42 from "./models/event.js"
import * as amdModule43 from "./models/expense.js"
import * as amdModule44 from "./models/expensearticle.js"
import * as amdModule45 from "./models/expensepayment.js"
import * as amdModule46 from "./models/expire-date.js"
import * as amdModule47 from "./models/file.js"
import * as amdModule48 from "./models/invoice-style.js"
import * as amdModule49 from "./models/invoice.js"
import * as amdModule50 from "./models/invoicegroup.js"
import * as amdModule51 from "./models/invoicemailsend.js"
import * as amdModule52 from "./models/invoiceproduct-tax.js"
import * as amdModule53 from "./models/invoiceproduct.js"
import * as amdModule54 from "./models/invoices-notifiche-sdi.js"
import * as amdModule55 from "./models/invoicetax.js"
import * as amdModule56 from "./models/log.js"
import * as amdModule57 from "./models/notification.js"
import * as amdModule58 from "./models/organization-custom-field.js"
import * as amdModule59 from "./models/organization.js"
import * as amdModule60 from "./models/payment-method.js"
import * as amdModule61 from "./models/payment.js"
import * as amdModule62 from "./models/plan.js"
import * as amdModule63 from "./models/product-category.js"
import * as amdModule64 from "./models/product-state.js"
import * as amdModule65 from "./models/product.js"
import * as amdModule66 from "./models/project-consensi.js"
import * as amdModule67 from "./models/project-state.js"
import * as amdModule68 from "./models/project.js"
import * as amdModule69 from "./models/reminder-setting.js"
import * as amdModule70 from "./models/reminder.js"
import * as amdModule71 from "./models/role.js"
import * as amdModule72 from "./models/sub-category.js"
import * as amdModule73 from "./models/subscription.js"
import * as amdModule74 from "./models/tag.js"
import * as amdModule75 from "./models/todo.js"
import * as amdModule76 from "./models/todolist.js"
import * as amdModule77 from "./models/user-calendar.js"
import * as amdModule78 from "./models/user-invoice-setting.js"
import * as amdModule79 from "./models/user-reminder.js"
import * as amdModule80 from "./models/user-sezionale.js"
import * as amdModule81 from "./models/user-tax.js"
import * as amdModule82 from "./models/workhour-state.js"
import * as amdModule83 from "./models/workhour.js"
import * as amdModule84 from "./services/session.js"
import * as amdModule85 from "./core-app.js"
import * as amdModule86 from "./formats.js"
import * as amdModule87 from "./initializers/fontawesome.js"
import * as amdModule88 from "./initializers/offline-banner.js"
import * as amdModule89 from "./instance-initializers/dev-host.js"
import * as amdModule90 from "./services/app-state.js"
import * as amdModule91 from "./services/application.js"
import * as amdModule92 from "./services/beebee-base.js"
import * as amdModule93 from "./services/document-sign.js"
import * as amdModule94 from "./services/idle-screensaver.js"
import * as amdModule95 from "./services/index-context.js"
import * as amdModule96 from "./services/log.js"
import * as amdModule97 from "./services/modal-stack.js"
import * as amdModule98 from "./services/modal.js"
import * as amdModule99 from "./services/new-record-factory.js"
import * as amdModule100 from "./services/notification-message.js"
import * as amdModule101 from "./services/privacy.js"
import * as amdModule102 from "./services/ringtone.js"
import * as amdModule103 from "./services/role-checker.js"
import * as amdModule104 from "./services/socket-sync.js"
import * as amdModule105 from "./services/socket-tracker.js"
import * as amdModule106 from "./services/third-party-boot.js"
import * as amdModule107 from "./services/window-viewport.js"
import * as amdModule108 from "./components/assicurazione-aosta-valley.js"
import * as amdModule109 from "./components/assicurazione-snow-care.js"
import * as amdModule110 from "./components/base-product-price.js"
import * as amdModule111 from "./components/bb-field.js"
import * as amdModule112 from "./components/checkout-detail.js"
import * as amdModule113 from "./components/checkout-product.js"
import * as amdModule114 from "./components/cookie-banner.js"
import * as amdModule115 from "./components/custom-modules.js"
import * as amdModule116 from "./components/detail-calendar.js"
import * as amdModule117 from "./components/empty-category.js"
import * as amdModule118 from "./components/human-age.js"
import * as amdModule119 from "./components/inline-login.js"
import * as amdModule120 from "./components/level-selector.js"
import * as amdModule121 from "./components/list-cart-product.js"
import * as amdModule122 from "./components/list-filters.js"
import * as amdModule123 from "./components/list-levels.js"
import * as amdModule124 from "./components/not-available-label.js"
import * as amdModule125 from "./components/private-calendar.js"
import * as amdModule126 from "./components/product-list.js"
import * as amdModule127 from "./components/render-level.js"
import * as amdModule128 from "./components/rich-text-with-components.js"
import * as amdModule129 from "./components/slide-prodotti.js"
import * as amdModule130 from "./components/vetrina-prodotti.js"
import * as amdModule131 from "./components/wrap-translation.js"
import * as amdModule132 from "./components/ember-popover.js"
import * as amdModule133 from "./components/ember-tooltip.js"
import * as amdModule134 from "./components/ember-notify.js"
import * as amdModule135 from "./components/ember-notify/message.js"
import * as amdModule136 from "./components/power-calendar-multiple.js"
import * as amdModule137 from "./components/power-calendar-multiple/days.js"
import * as amdModule138 from "./components/power-calendar-range.js"
import * as amdModule139 from "./components/power-calendar-range/days.js"
import * as amdModule140 from "./components/power-calendar.js"
import * as amdModule141 from "./components/power-calendar/days.js"
import * as amdModule142 from "./components/power-calendar/nav.js"
import * as amdModule143 from "./components/payment-method.js"
import * as amdModule144 from "./components/payment-method/payment-section.js"
import * as amdModule145 from "./components/bb-checkbox.js"
import * as amdModule146 from "./components/bb-chip-group.js"
import * as amdModule147 from "./components/bb-color-picker.js"
import * as amdModule148 from "./components/bb-date-range.js"
import * as amdModule149 from "./components/bb-editor.js"
import * as amdModule150 from "./components/bb-focus-input.js"
import * as amdModule151 from "./components/bb-input-currency.js"
import * as amdModule152 from "./components/bb-input-date.js"
import * as amdModule153 from "./components/bb-input-number.js"
import * as amdModule154 from "./components/bb-input-suggestion.js"
import * as amdModule155 from "./components/bb-input-tel.js"
import * as amdModule156 from "./components/bb-radio.js"
import * as amdModule157 from "./components/bb-range-slider.js"
import * as amdModule158 from "./components/bb-select.js"
import * as amdModule159 from "./components/bb-slider.js"
import * as amdModule160 from "./components/bb-textarea.js"
import * as amdModule161 from "./components/bb-toggle.js"
import * as amdModule162 from "./components/quill-editor.js"
import * as amdModule163 from "./components/quill.js"
import * as amdModule164 from "./components/quill/toolbar.js"
import * as amdModule165 from "./components/quill/toolbar/button-or-select.js"
import * as amdModule166 from "./components/quill/toolbar/button.js"
import * as amdModule167 from "./components/quill/toolbar/group.js"
import * as amdModule168 from "./components/quill/toolbar/select.js"
import * as amdModule169 from "./components/bb-custom-field-preview.js"
import * as amdModule170 from "./components/cf-advanced-textarea.js"
import * as amdModule171 from "./components/cf-table.js"
import * as amdModule172 from "./components/custom-field-value.js"
import * as amdModule173 from "./components/edit-custom-field.js"
import * as amdModule174 from "./components/view-custom-field.js"
import * as amdModule175 from "./components/bb-clock.js"
import * as amdModule176 from "./components/bb-time-ago.js"
import * as amdModule177 from "./components/belongs-to.js"
import * as amdModule178 from "./components/has-many.js"
import * as amdModule179 from "./components/related-contacts.js"
import * as amdModule180 from "./components/related-invoices.js"
import * as amdModule181 from "./components/select-association.js"
import * as amdModule182 from "./components/select-association/filter-bar.js"
import * as amdModule183 from "./components/select-association/result-list.js"
import * as amdModule184 from "./components/show-association.js"
import * as amdModule185 from "./components/addresses-list.js"
import * as amdModule186 from "./components/edit-single-address.js"
import * as amdModule187 from "./components/here-map.js"
import * as amdModule188 from "./components/related-addresses.js"
import * as amdModule189 from "./components/base-beebee-component.js"
import * as amdModule190 from "./components/base-edit-component.js"
import * as amdModule191 from "./components/bb-associate-button.js"
import * as amdModule192 from "./components/bb-birth-place-picker.js"
import * as amdModule193 from "./components/bb-chart.js"
import * as amdModule194 from "./components/bb-delete-button.js"
import * as amdModule195 from "./components/bb-dev-toolbar.js"
import * as amdModule196 from "./components/bb-draggable.js"
import * as amdModule197 from "./components/bb-dropdown.js"
import * as amdModule198 from "./components/bb-dropzone.js"
import * as amdModule199 from "./components/bb-email-history.js"
import * as amdModule200 from "./components/bb-expire-date.js"
import * as amdModule201 from "./components/bb-footer-mobile.js"
import * as amdModule202 from "./components/bb-has-many-paginator.js"
import * as amdModule203 from "./components/bb-help-widget.js"
import * as amdModule204 from "./components/bb-list-checkbox.js"
import * as amdModule205 from "./components/bb-list-filter.js"
import * as amdModule206 from "./components/bb-log-modal.js"
import * as amdModule207 from "./components/bb-mascot-loader.js"
import * as amdModule208 from "./components/bb-modal-modern.js"
import * as amdModule209 from "./components/bb-modal.js"
import * as amdModule210 from "./components/bb-paginator.js"
import * as amdModule211 from "./components/bb-panel.js"
import * as amdModule212 from "./components/bb-payment-form-modal.js"
import * as amdModule213 from "./components/bb-payments-list.js"
import * as amdModule214 from "./components/bb-pdf-viewer.js"
import * as amdModule215 from "./components/bb-presence-indicator.js"
import * as amdModule216 from "./components/bb-presence-list.js"
import * as amdModule217 from "./components/bb-reminder-board.js"
import * as amdModule218 from "./components/bb-save-menu.js"
import * as amdModule219 from "./components/bb-spinner.js"
import * as amdModule220 from "./components/bb-status-picker.js"
import * as amdModule221 from "./components/bb-tenant-palette.js"
import * as amdModule222 from "./components/bb-thumbnail.js"
import * as amdModule223 from "./components/bb-translations-unavailable.js"
import * as amdModule224 from "./components/bb-user-browser.js"
import * as amdModule225 from "./components/bb-user-platform.js"
import * as amdModule226 from "./components/power-select.js"
import * as amdModule227 from "./components/power-select/before-options.js"
import * as amdModule228 from "./components/power-select/input.js"
import * as amdModule229 from "./components/power-select/label.js"
import * as amdModule230 from "./components/power-select/no-matches-message.js"
import * as amdModule231 from "./components/power-select/options.js"
import * as amdModule232 from "./components/power-select/placeholder.js"
import * as amdModule233 from "./components/power-select/power-select-group.js"
import * as amdModule234 from "./components/power-select/search-message.js"
import * as amdModule235 from "./components/power-select/trigger.js"
import * as amdModule236 from "./components/basic-dropdown-content.js"
import * as amdModule237 from "./components/basic-dropdown-trigger.js"
import * as amdModule238 from "./components/basic-dropdown-wormhole.js"
import * as amdModule239 from "./components/basic-dropdown.js"
import * as amdModule240 from "./components/fa-icon.js"
import * as amdModule241 from "./helpers/format-date.js"
import * as amdModule242 from "./helpers/format-hour.js"
import * as amdModule243 from "./helpers/format-number.js"
import * as amdModule244 from "./helpers/t.js"
import * as amdModule245 from "./helpers/thumb-letter.js"
import * as amdModule246 from "./helpers/ensure-safe-component.js"
import * as amdModule247 from "./helpers/app-version.js"
import * as amdModule248 from "./helpers/pluralize.js"
import * as amdModule249 from "./helpers/singularize.js"
import * as amdModule250 from "./helpers/ember-power-calendar-day-classes.js"
import * as amdModule251 from "./helpers/power-calendar-format-date.js"
import * as amdModule252 from "./helpers/and.js"
import * as amdModule253 from "./helpers/eq.js"
import * as amdModule254 from "./helpers/gt.js"
import * as amdModule255 from "./helpers/gte.js"
import * as amdModule256 from "./helpers/is-array.js"
import * as amdModule257 from "./helpers/is-empty.js"
import * as amdModule258 from "./helpers/is-equal.js"
import * as amdModule259 from "./helpers/lt.js"
import * as amdModule260 from "./helpers/lte.js"
import * as amdModule261 from "./helpers/not-eq.js"
import * as amdModule262 from "./helpers/not.js"
import * as amdModule263 from "./helpers/or.js"
import * as amdModule264 from "./helpers/xor.js"
import * as amdModule265 from "./helpers/assign.js"
import * as amdModule266 from "./helpers/if-key.js"
import * as amdModule267 from "./helpers/on-key.js"
import * as amdModule268 from "./helpers/brightness-by-color.js"
import * as amdModule269 from "./helpers/collection-contain.js"
import * as amdModule270 from "./helpers/collection-list.js"
import * as amdModule271 from "./helpers/component-exists.js"
import * as amdModule272 from "./helpers/concat-string.js"
import * as amdModule273 from "./helpers/contact-name.js"
import * as amdModule274 from "./helpers/css-style.js"
import * as amdModule275 from "./helpers/custom-field-icon.js"
import * as amdModule276 from "./helpers/date-diff-year.js"
import * as amdModule277 from "./helpers/date-diff.js"
import * as amdModule278 from "./helpers/date-ticks.js"
import * as amdModule279 from "./helpers/day-name.js"
import * as amdModule280 from "./helpers/def-currency.js"
import * as amdModule281 from "./helpers/first-object.js"
import * as amdModule282 from "./helpers/format-euro.js"
import * as amdModule283 from "./helpers/format-minute2string-day.js"
import * as amdModule284 from "./helpers/format-minute2string.js"
import * as amdModule285 from "./helpers/format-number2string.js"
import * as amdModule286 from "./helpers/generate-id.js"
import * as amdModule287 from "./helpers/human-custom-field-name.js"
import * as amdModule288 from "./helpers/icon-here.js"
import * as amdModule289 from "./helpers/in-array.js"
import * as amdModule290 from "./helpers/is-equal-large.js"
import * as amdModule291 from "./helpers/is-equal-not-empty.js"
import * as amdModule292 from "./helpers/is-gt.js"
import * as amdModule293 from "./helpers/is-image.js"
import * as amdModule294 from "./helpers/is-not.js"
import * as amdModule295 from "./helpers/is-pdf.js"
import * as amdModule296 from "./helpers/number-diff.js"
import * as amdModule297 from "./helpers/number-div.js"
import * as amdModule298 from "./helpers/number-mult.js"
import * as amdModule299 from "./helpers/number-sum.js"
import * as amdModule300 from "./helpers/number-to-hour.js"
import * as amdModule301 from "./helpers/read-path.js"
import * as amdModule302 from "./helpers/replace-br2comas.js"
import * as amdModule303 from "./helpers/safe-string.js"
import * as amdModule304 from "./helpers/set.js"
import * as amdModule305 from "./helpers/time-tickstotext.js"
import * as amdModule306 from "./helpers/todo-date-diff.js"
import * as amdModule307 from "./helpers/ember-power-select-is-array.js"
import * as amdModule308 from "./helpers/ember-power-select-is-equal.js"
import * as amdModule309 from "./helpers/ember-power-select-is-group.js"
import * as amdModule310 from "./helpers/ember-power-select-is-selected-present.js"
import * as amdModule311 from "./helpers/format-date-range.js"
import * as amdModule312 from "./helpers/format-display-name.js"
import * as amdModule313 from "./helpers/format-list.js"
import * as amdModule314 from "./helpers/format-message.js"
import * as amdModule315 from "./helpers/format-relative-time.js"
import * as amdModule316 from "./helpers/format-time.js"
import * as amdModule317 from "./helpers/t-key.js"
import * as amdModule318 from "./helpers/cancel-all.js"
import * as amdModule319 from "./helpers/perform.js"
import * as amdModule320 from "./helpers/task.js"
import * as amdModule321 from "./helpers/element.js"
import * as amdModule322 from "./modifiers/on-key.js"
import * as amdModule323 from "./modifiers/autofocus.js"
import * as amdModule324 from "./modifiers/dhtmlx-tooltip-guard.js"
import * as amdModule325 from "./modifiers/scroll-top-on-insert.js"
import * as amdModule326 from "./modifiers/basic-dropdown-trigger.js"
import * as amdModule327 from "./modifiers/style.js"
import * as amdModule328 from "./modifiers/did-insert.js"
import * as amdModule329 from "./modifiers/did-update.js"
import * as amdModule330 from "./modifiers/will-destroy.js"
import * as amdModule331 from "./templates/application.hbs"
import * as amdModule332 from "./controllers/application.js"
import * as amdModule333 from "./routes/application.js"
import * as amdModule334 from "./templates/checkin.hbs"
import * as amdModule335 from "./controllers/checkin.js"
import * as amdModule336 from "./routes/checkin.js"
import * as amdModule337 from "./templates/checkout.hbs"
import * as amdModule338 from "./controllers/checkout.js"
import * as amdModule339 from "./routes/checkout.js"
import * as amdModule340 from "./templates/confirm.hbs"
import * as amdModule341 from "./controllers/confirm.js"
import * as amdModule342 from "./routes/confirm.js"
import * as amdModule343 from "./templates/detail.hbs"
import * as amdModule344 from "./controllers/detail.js"
import * as amdModule345 from "./routes/detail.js"
import * as amdModule346 from "./templates/gift.hbs"
import * as amdModule347 from "./controllers/gift.js"
import * as amdModule348 from "./routes/gift.js"
import * as amdModule349 from "./templates/index.hbs"
import * as amdModule350 from "./controllers/index.js"
import * as amdModule351 from "./routes/index.js"
import * as amdModule352 from "./templates/list.hbs"
import * as amdModule353 from "./controllers/list.js"
import * as amdModule354 from "./routes/list.js"
import * as amdModule355 from "./templates/payment-request.hbs"
import * as amdModule356 from "./controllers/payment-request.js"
import * as amdModule357 from "./routes/payment-request.js"
import * as amdModule358 from "./templates/payment-status.hbs"
import * as amdModule359 from "./controllers/payment-status.js"
import * as amdModule360 from "./routes/payment-status.js"
import * as amdModule361 from "./templates/ski-instructor.hbs"
import * as amdModule362 from "./controllers/ski-instructor.js"
import * as amdModule363 from "./routes/ski-instructor.js"
import * as amdModule364 from "./templates/user.hbs"
import * as amdModule365 from "./controllers/user.js"
import * as amdModule366 from "./routes/user.js"
import * as amdModule367 from "./routes/private.js"
import * as amdModule368 from "./templates/404.hbs"
import * as amdModule369 from "./templates/error.hbs"
import * as amdModule370 from "./templates/loading.hbs"
import * as amdModule371 from "./routes/token-login.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"e-commerce/initializers/ember-data-identifiers": amdModule0,
"e-commerce/lib/checkout-contact-controller": amdModule1,
"e-commerce/lib/checkout-payload": amdModule2,
"e-commerce/lib/confirm-error": amdModule3,
"e-commerce/lib/default-comprensorio": amdModule4,
"e-commerce/lib/fiscal-contact-validation": amdModule5,
"e-commerce/resolver": amdModule6,
"e-commerce/router": amdModule7,
"e-commerce/serializers/application": amdModule8,
"e-commerce/services/intl": amdModule9,
"e-commerce/services/keyboard": amdModule10,
"e-commerce/services/theme": amdModule11,
"e-commerce/services/-ensure-registered": amdModule12,
"e-commerce/services/notify": amdModule13,
"e-commerce/initializers/app-version": amdModule14,
"e-commerce/instance-initializers/sentry-performance": amdModule15,
"e-commerce/instance-initializers/load-translations": amdModule16,
"e-commerce/services/power-calendar": amdModule17,
"e-commerce/test-support/helpers": amdModule18,
"e-commerce/initializers/ember-data": amdModule19,
"e-commerce/services/store": amdModule20,
"e-commerce/transforms/date": amdModule21,
"e-commerce/transforms/number": amdModule22,
"e-commerce/transforms/string": amdModule23,
"e-commerce/transforms/boolean": amdModule24,
"e-commerce/data-adapter": amdModule25,
"e-commerce/services/quill": amdModule26,
"e-commerce/adapters/application": amdModule27,
"e-commerce/adapters/contact": amdModule28,
"e-commerce/adapters/organization": amdModule29,
"e-commerce/models/address": amdModule30,
"e-commerce/models/application": amdModule31,
"e-commerce/models/assurance": amdModule32,
"e-commerce/models/category": amdModule33,
"e-commerce/models/contact-consensi": amdModule34,
"e-commerce/models/contact-parent": amdModule35,
"e-commerce/models/contact-state": amdModule36,
"e-commerce/models/contact": amdModule37,
"e-commerce/models/custom-field-definition": amdModule38,
"e-commerce/models/custom-field": amdModule39,
"e-commerce/models/custom-reminder": amdModule40,
"e-commerce/models/event-state": amdModule41,
"e-commerce/models/event": amdModule42,
"e-commerce/models/expense": amdModule43,
"e-commerce/models/expensearticle": amdModule44,
"e-commerce/models/expensepayment": amdModule45,
"e-commerce/models/expire-date": amdModule46,
"e-commerce/models/file": amdModule47,
"e-commerce/models/invoice-style": amdModule48,
"e-commerce/models/invoice": amdModule49,
"e-commerce/models/invoicegroup": amdModule50,
"e-commerce/models/invoicemailsend": amdModule51,
"e-commerce/models/invoiceproduct-tax": amdModule52,
"e-commerce/models/invoiceproduct": amdModule53,
"e-commerce/models/invoices-notifiche-sdi": amdModule54,
"e-commerce/models/invoicetax": amdModule55,
"e-commerce/models/log": amdModule56,
"e-commerce/models/notification": amdModule57,
"e-commerce/models/organization-custom-field": amdModule58,
"e-commerce/models/organization": amdModule59,
"e-commerce/models/payment-method": amdModule60,
"e-commerce/models/payment": amdModule61,
"e-commerce/models/plan": amdModule62,
"e-commerce/models/product-category": amdModule63,
"e-commerce/models/product-state": amdModule64,
"e-commerce/models/product": amdModule65,
"e-commerce/models/project-consensi": amdModule66,
"e-commerce/models/project-state": amdModule67,
"e-commerce/models/project": amdModule68,
"e-commerce/models/reminder-setting": amdModule69,
"e-commerce/models/reminder": amdModule70,
"e-commerce/models/role": amdModule71,
"e-commerce/models/sub-category": amdModule72,
"e-commerce/models/subscription": amdModule73,
"e-commerce/models/tag": amdModule74,
"e-commerce/models/todo": amdModule75,
"e-commerce/models/todolist": amdModule76,
"e-commerce/models/user-calendar": amdModule77,
"e-commerce/models/user-invoice-setting": amdModule78,
"e-commerce/models/user-reminder": amdModule79,
"e-commerce/models/user-sezionale": amdModule80,
"e-commerce/models/user-tax": amdModule81,
"e-commerce/models/workhour-state": amdModule82,
"e-commerce/models/workhour": amdModule83,
"e-commerce/services/session": amdModule84,
"e-commerce/core-app": amdModule85,
"e-commerce/formats": amdModule86,
"e-commerce/initializers/fontawesome": amdModule87,
"e-commerce/initializers/offline-banner": amdModule88,
"e-commerce/instance-initializers/dev-host": amdModule89,
"e-commerce/services/app-state": amdModule90,
"e-commerce/services/application": amdModule91,
"e-commerce/services/beebee-base": amdModule92,
"e-commerce/services/document-sign": amdModule93,
"e-commerce/services/idle-screensaver": amdModule94,
"e-commerce/services/index-context": amdModule95,
"e-commerce/services/log": amdModule96,
"e-commerce/services/modal-stack": amdModule97,
"e-commerce/services/modal": amdModule98,
"e-commerce/services/new-record-factory": amdModule99,
"e-commerce/services/notification-message": amdModule100,
"e-commerce/services/privacy": amdModule101,
"e-commerce/services/ringtone": amdModule102,
"e-commerce/services/role-checker": amdModule103,
"e-commerce/services/socket-sync": amdModule104,
"e-commerce/services/socket-tracker": amdModule105,
"e-commerce/services/third-party-boot": amdModule106,
"e-commerce/services/window-viewport": amdModule107,
"e-commerce/components/assicurazione-aosta-valley": amdModule108,
"e-commerce/components/assicurazione-snow-care": amdModule109,
"e-commerce/components/base-product-price": amdModule110,
"e-commerce/components/bb-field": amdModule111,
"e-commerce/components/checkout-detail": amdModule112,
"e-commerce/components/checkout-product": amdModule113,
"e-commerce/components/cookie-banner": amdModule114,
"e-commerce/components/custom-modules": amdModule115,
"e-commerce/components/detail-calendar": amdModule116,
"e-commerce/components/empty-category": amdModule117,
"e-commerce/components/human-age": amdModule118,
"e-commerce/components/inline-login": amdModule119,
"e-commerce/components/level-selector": amdModule120,
"e-commerce/components/list-cart-product": amdModule121,
"e-commerce/components/list-filters": amdModule122,
"e-commerce/components/list-levels": amdModule123,
"e-commerce/components/not-available-label": amdModule124,
"e-commerce/components/private-calendar": amdModule125,
"e-commerce/components/product-list": amdModule126,
"e-commerce/components/render-level": amdModule127,
"e-commerce/components/rich-text-with-components": amdModule128,
"e-commerce/components/slide-prodotti": amdModule129,
"e-commerce/components/vetrina-prodotti": amdModule130,
"e-commerce/components/wrap-translation": amdModule131,
"e-commerce/components/ember-popover": amdModule132,
"e-commerce/components/ember-tooltip": amdModule133,
"e-commerce/components/ember-notify": amdModule134,
"e-commerce/components/ember-notify/message": amdModule135,
"e-commerce/components/power-calendar-multiple": amdModule136,
"e-commerce/components/power-calendar-multiple/days": amdModule137,
"e-commerce/components/power-calendar-range": amdModule138,
"e-commerce/components/power-calendar-range/days": amdModule139,
"e-commerce/components/power-calendar": amdModule140,
"e-commerce/components/power-calendar/days": amdModule141,
"e-commerce/components/power-calendar/nav": amdModule142,
"e-commerce/components/payment-method": amdModule143,
"e-commerce/components/payment-method/payment-section": amdModule144,
"e-commerce/components/bb-checkbox": amdModule145,
"e-commerce/components/bb-chip-group": amdModule146,
"e-commerce/components/bb-color-picker": amdModule147,
"e-commerce/components/bb-date-range": amdModule148,
"e-commerce/components/bb-editor": amdModule149,
"e-commerce/components/bb-focus-input": amdModule150,
"e-commerce/components/bb-input-currency": amdModule151,
"e-commerce/components/bb-input-date": amdModule152,
"e-commerce/components/bb-input-number": amdModule153,
"e-commerce/components/bb-input-suggestion": amdModule154,
"e-commerce/components/bb-input-tel": amdModule155,
"e-commerce/components/bb-radio": amdModule156,
"e-commerce/components/bb-range-slider": amdModule157,
"e-commerce/components/bb-select": amdModule158,
"e-commerce/components/bb-slider": amdModule159,
"e-commerce/components/bb-textarea": amdModule160,
"e-commerce/components/bb-toggle": amdModule161,
"e-commerce/components/quill-editor": amdModule162,
"e-commerce/components/quill": amdModule163,
"e-commerce/components/quill/toolbar": amdModule164,
"e-commerce/components/quill/toolbar/button-or-select": amdModule165,
"e-commerce/components/quill/toolbar/button": amdModule166,
"e-commerce/components/quill/toolbar/group": amdModule167,
"e-commerce/components/quill/toolbar/select": amdModule168,
"e-commerce/components/bb-custom-field-preview": amdModule169,
"e-commerce/components/cf-advanced-textarea": amdModule170,
"e-commerce/components/cf-table": amdModule171,
"e-commerce/components/custom-field-value": amdModule172,
"e-commerce/components/edit-custom-field": amdModule173,
"e-commerce/components/view-custom-field": amdModule174,
"e-commerce/components/bb-clock": amdModule175,
"e-commerce/components/bb-time-ago": amdModule176,
"e-commerce/components/belongs-to": amdModule177,
"e-commerce/components/has-many": amdModule178,
"e-commerce/components/related-contacts": amdModule179,
"e-commerce/components/related-invoices": amdModule180,
"e-commerce/components/select-association": amdModule181,
"e-commerce/components/select-association/filter-bar": amdModule182,
"e-commerce/components/select-association/result-list": amdModule183,
"e-commerce/components/show-association": amdModule184,
"e-commerce/components/addresses-list": amdModule185,
"e-commerce/components/edit-single-address": amdModule186,
"e-commerce/components/here-map": amdModule187,
"e-commerce/components/related-addresses": amdModule188,
"e-commerce/components/base-beebee-component": amdModule189,
"e-commerce/components/base-edit-component": amdModule190,
"e-commerce/components/bb-associate-button": amdModule191,
"e-commerce/components/bb-birth-place-picker": amdModule192,
"e-commerce/components/bb-chart": amdModule193,
"e-commerce/components/bb-delete-button": amdModule194,
"e-commerce/components/bb-dev-toolbar": amdModule195,
"e-commerce/components/bb-draggable": amdModule196,
"e-commerce/components/bb-dropdown": amdModule197,
"e-commerce/components/bb-dropzone": amdModule198,
"e-commerce/components/bb-email-history": amdModule199,
"e-commerce/components/bb-expire-date": amdModule200,
"e-commerce/components/bb-footer-mobile": amdModule201,
"e-commerce/components/bb-has-many-paginator": amdModule202,
"e-commerce/components/bb-help-widget": amdModule203,
"e-commerce/components/bb-list-checkbox": amdModule204,
"e-commerce/components/bb-list-filter": amdModule205,
"e-commerce/components/bb-log-modal": amdModule206,
"e-commerce/components/bb-mascot-loader": amdModule207,
"e-commerce/components/bb-modal-modern": amdModule208,
"e-commerce/components/bb-modal": amdModule209,
"e-commerce/components/bb-paginator": amdModule210,
"e-commerce/components/bb-panel": amdModule211,
"e-commerce/components/bb-payment-form-modal": amdModule212,
"e-commerce/components/bb-payments-list": amdModule213,
"e-commerce/components/bb-pdf-viewer": amdModule214,
"e-commerce/components/bb-presence-indicator": amdModule215,
"e-commerce/components/bb-presence-list": amdModule216,
"e-commerce/components/bb-reminder-board": amdModule217,
"e-commerce/components/bb-save-menu": amdModule218,
"e-commerce/components/bb-spinner": amdModule219,
"e-commerce/components/bb-status-picker": amdModule220,
"e-commerce/components/bb-tenant-palette": amdModule221,
"e-commerce/components/bb-thumbnail": amdModule222,
"e-commerce/components/bb-translations-unavailable": amdModule223,
"e-commerce/components/bb-user-browser": amdModule224,
"e-commerce/components/bb-user-platform": amdModule225,
"e-commerce/components/power-select": amdModule226,
"e-commerce/components/power-select/before-options": amdModule227,
"e-commerce/components/power-select/input": amdModule228,
"e-commerce/components/power-select/label": amdModule229,
"e-commerce/components/power-select/no-matches-message": amdModule230,
"e-commerce/components/power-select/options": amdModule231,
"e-commerce/components/power-select/placeholder": amdModule232,
"e-commerce/components/power-select/power-select-group": amdModule233,
"e-commerce/components/power-select/search-message": amdModule234,
"e-commerce/components/power-select/trigger": amdModule235,
"e-commerce/components/basic-dropdown-content": amdModule236,
"e-commerce/components/basic-dropdown-trigger": amdModule237,
"e-commerce/components/basic-dropdown-wormhole": amdModule238,
"e-commerce/components/basic-dropdown": amdModule239,
"e-commerce/components/fa-icon": amdModule240,
"e-commerce/helpers/format-date": amdModule241,
"e-commerce/helpers/format-hour": amdModule242,
"e-commerce/helpers/format-number": amdModule243,
"e-commerce/helpers/t": amdModule244,
"e-commerce/helpers/thumb-letter": amdModule245,
"e-commerce/helpers/ensure-safe-component": amdModule246,
"e-commerce/helpers/app-version": amdModule247,
"e-commerce/helpers/pluralize": amdModule248,
"e-commerce/helpers/singularize": amdModule249,
"e-commerce/helpers/ember-power-calendar-day-classes": amdModule250,
"e-commerce/helpers/power-calendar-format-date": amdModule251,
"e-commerce/helpers/and": amdModule252,
"e-commerce/helpers/eq": amdModule253,
"e-commerce/helpers/gt": amdModule254,
"e-commerce/helpers/gte": amdModule255,
"e-commerce/helpers/is-array": amdModule256,
"e-commerce/helpers/is-empty": amdModule257,
"e-commerce/helpers/is-equal": amdModule258,
"e-commerce/helpers/lt": amdModule259,
"e-commerce/helpers/lte": amdModule260,
"e-commerce/helpers/not-eq": amdModule261,
"e-commerce/helpers/not": amdModule262,
"e-commerce/helpers/or": amdModule263,
"e-commerce/helpers/xor": amdModule264,
"e-commerce/helpers/assign": amdModule265,
"e-commerce/helpers/if-key": amdModule266,
"e-commerce/helpers/on-key": amdModule267,
"e-commerce/helpers/brightness-by-color": amdModule268,
"e-commerce/helpers/collection-contain": amdModule269,
"e-commerce/helpers/collection-list": amdModule270,
"e-commerce/helpers/component-exists": amdModule271,
"e-commerce/helpers/concat-string": amdModule272,
"e-commerce/helpers/contact-name": amdModule273,
"e-commerce/helpers/css-style": amdModule274,
"e-commerce/helpers/custom-field-icon": amdModule275,
"e-commerce/helpers/date-diff-year": amdModule276,
"e-commerce/helpers/date-diff": amdModule277,
"e-commerce/helpers/date-ticks": amdModule278,
"e-commerce/helpers/day-name": amdModule279,
"e-commerce/helpers/def-currency": amdModule280,
"e-commerce/helpers/first-object": amdModule281,
"e-commerce/helpers/format-euro": amdModule282,
"e-commerce/helpers/format-minute2string-day": amdModule283,
"e-commerce/helpers/format-minute2string": amdModule284,
"e-commerce/helpers/format-number2string": amdModule285,
"e-commerce/helpers/generate-id": amdModule286,
"e-commerce/helpers/human-custom-field-name": amdModule287,
"e-commerce/helpers/icon-here": amdModule288,
"e-commerce/helpers/in-array": amdModule289,
"e-commerce/helpers/is-equal-large": amdModule290,
"e-commerce/helpers/is-equal-not-empty": amdModule291,
"e-commerce/helpers/is-gt": amdModule292,
"e-commerce/helpers/is-image": amdModule293,
"e-commerce/helpers/is-not": amdModule294,
"e-commerce/helpers/is-pdf": amdModule295,
"e-commerce/helpers/number-diff": amdModule296,
"e-commerce/helpers/number-div": amdModule297,
"e-commerce/helpers/number-mult": amdModule298,
"e-commerce/helpers/number-sum": amdModule299,
"e-commerce/helpers/number-to-hour": amdModule300,
"e-commerce/helpers/read-path": amdModule301,
"e-commerce/helpers/replace-br2comas": amdModule302,
"e-commerce/helpers/safe-string": amdModule303,
"e-commerce/helpers/set": amdModule304,
"e-commerce/helpers/time-tickstotext": amdModule305,
"e-commerce/helpers/todo-date-diff": amdModule306,
"e-commerce/helpers/ember-power-select-is-array": amdModule307,
"e-commerce/helpers/ember-power-select-is-equal": amdModule308,
"e-commerce/helpers/ember-power-select-is-group": amdModule309,
"e-commerce/helpers/ember-power-select-is-selected-present": amdModule310,
"e-commerce/helpers/format-date-range": amdModule311,
"e-commerce/helpers/format-display-name": amdModule312,
"e-commerce/helpers/format-list": amdModule313,
"e-commerce/helpers/format-message": amdModule314,
"e-commerce/helpers/format-relative-time": amdModule315,
"e-commerce/helpers/format-time": amdModule316,
"e-commerce/helpers/t-key": amdModule317,
"e-commerce/helpers/cancel-all": amdModule318,
"e-commerce/helpers/perform": amdModule319,
"e-commerce/helpers/task": amdModule320,
"e-commerce/helpers/element": amdModule321,
"e-commerce/modifiers/on-key": amdModule322,
"e-commerce/modifiers/autofocus": amdModule323,
"e-commerce/modifiers/dhtmlx-tooltip-guard": amdModule324,
"e-commerce/modifiers/scroll-top-on-insert": amdModule325,
"e-commerce/modifiers/basic-dropdown-trigger": amdModule326,
"e-commerce/modifiers/style": amdModule327,
"e-commerce/modifiers/did-insert": amdModule328,
"e-commerce/modifiers/did-update": amdModule329,
"e-commerce/modifiers/will-destroy": amdModule330,
"e-commerce/templates/application": amdModule331,
"e-commerce/controllers/application": amdModule332,
"e-commerce/routes/application": amdModule333,
"e-commerce/templates/checkin": amdModule334,
"e-commerce/controllers/checkin": amdModule335,
"e-commerce/routes/checkin": amdModule336,
"e-commerce/templates/checkout": amdModule337,
"e-commerce/controllers/checkout": amdModule338,
"e-commerce/routes/checkout": amdModule339,
"e-commerce/templates/confirm": amdModule340,
"e-commerce/controllers/confirm": amdModule341,
"e-commerce/routes/confirm": amdModule342,
"e-commerce/templates/detail": amdModule343,
"e-commerce/controllers/detail": amdModule344,
"e-commerce/routes/detail": amdModule345,
"e-commerce/templates/gift": amdModule346,
"e-commerce/controllers/gift": amdModule347,
"e-commerce/routes/gift": amdModule348,
"e-commerce/templates/index": amdModule349,
"e-commerce/controllers/index": amdModule350,
"e-commerce/routes/index": amdModule351,
"e-commerce/templates/list": amdModule352,
"e-commerce/controllers/list": amdModule353,
"e-commerce/routes/list": amdModule354,
"e-commerce/templates/payment-request": amdModule355,
"e-commerce/controllers/payment-request": amdModule356,
"e-commerce/routes/payment-request": amdModule357,
"e-commerce/templates/payment-status": amdModule358,
"e-commerce/controllers/payment-status": amdModule359,
"e-commerce/routes/payment-status": amdModule360,
"e-commerce/templates/ski-instructor": amdModule361,
"e-commerce/controllers/ski-instructor": amdModule362,
"e-commerce/routes/ski-instructor": amdModule363,
"e-commerce/templates/user": amdModule364,
"e-commerce/controllers/user": amdModule365,
"e-commerce/routes/user": amdModule366,
"e-commerce/routes/private": amdModule367,
"e-commerce/templates/404": amdModule368,
"e-commerce/templates/error": amdModule369,
"e-commerce/templates/loading": amdModule370,
"e-commerce/routes/token-login": amdModule371,
  },
  exportFastbootModules
);
